<template>
    <v-input v-model="modelValue" :rules="rules">
        <v-rating v-model="modelValue" class="ma-2" :length="maxLength" density="default" clearable></v-rating>
    </v-input>
</template>

<script setup>
import { defineModel, defineProps } from "vue"
const modelValue = defineModel({
    required: true,
    type: Number
})
const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },
    maxLength: {
        type: Number,
        default: () => {
            return 5
        },
        required: true
    }
})
const rules = [
    (v) => {
        return !props.required || !!v || "Silahkan isi bagian ini"
    }
]
</script>

<style lang="scss" scoped></style>